import EmblaCarousel from 'embla-carousel';
import ClassNames from 'embla-carousel-class-names';
const product = () => {
    const selectors = {
        mainProductSection: '[data-main-product]',
        productID: 'data-product-id',
        productHandle: 'data-product-handle',
        productInfo: '[data-product-info]',
        productForm: 'product-form',
        productImageContainer: '[data-product-image]',
        productDefaultImage: '[data-default-image]',
        currentVariant: 'data-variant-id',
        staticATC: '[data-static-add-to-cart]',
        stickyATC: '[data-sticky-add-to-cart]',
        pseudoVariantsCarousel: '[data-pseudo-variants-carousel]',
        pseudoVariantsCarouselViewport: '[data-pseudo-variants-carousel-viewport]',
        variantCarousel: '[data-variant-swatches-carousel]',
        variantCarouselViewport: '[data-variant-swatches-carousel-viewport]',
        variantCarouselPrev: '[data-variant-swatches-carousel-prev]',
        variantCarouselNext: '[data-variant-swatches-carousel-next]',
        variantCarouselSlide: '.embla__slide',
        swatchGrid: 'data-variant-swatches-wrapper',
        swatchGridSwatch: '.swatch',
        productAccordionBlock: '[data-product-accordion-block]',
        accordionTitle: '[data-accordion-title]',
        accordionContent: '[data-accordion-content]',
        openOnLoad: 'open-on-load',
        footer: 'footer',
        summary: '[data-selected-variant-summary]',
    };
    const classes = {
        showStickyATC: 'sticky-add-to-cart--show',
        accordionOpen: 'product__accordion--open',
        hoverLeft: 'embla--hover-left',
        hoverRight: 'embla--hover-right',
    };
    const mainProductSections = document.querySelectorAll(selectors.mainProductSection);
    mainProductSections.forEach((section) => {
        const productInfo = section.querySelector(selectors.productInfo);
        // Add to Recently Viewed
        const productHandle = section.getAttribute(selectors.productHandle);
        let viewedProducts = JSON.parse(sessionStorage.getItem('frank-green:recently-viewed-products'));
        if (!viewedProducts) {
            viewedProducts = [];
        }
        viewedProducts.push(productHandle);
        const uniqueViewedProducts = viewedProducts.filter((element, index) => {
            return viewedProducts.indexOf(element) === index;
        });
        sessionStorage.setItem('frank-green:recently-viewed-products', JSON.stringify(uniqueViewedProducts));
        // Sticky Add-to-Cart
        const staticATC = section.querySelector(selectors.staticATC);
        const stickyATC = section.querySelector(selectors.stickyATC);
        const footer = document.querySelector(selectors.footer);
        if (staticATC) {
            window.addEventListener('scroll', () => {
                const productFormTop = staticATC.getBoundingClientRect().top;
                const footerTop = footer.getBoundingClientRect().top;
                if (productFormTop < -50) {
                    stickyATC.classList.add(classes.showStickyATC);
                }
                else {
                    stickyATC.classList.remove(classes.showStickyATC);
                }
                if (footerTop < window.innerHeight) {
                    stickyATC.classList.remove(classes.showStickyATC);
                }
            });
        }
        if (stickyATC) {
            stickyATC.addEventListener('click', () => {
                staticATC.querySelector('.product-form__buttons button').click();
            });
        }
        // Swatches - Variant Images
        const variantCarousels = section.querySelectorAll(selectors.variantCarousel);
        if (variantCarousels) {
            variantCarousels.forEach((carousel) => {
                const carouselID = carousel.dataset.variantSwatchesCarousel;
                const swatchGrid = section.querySelector(`[${selectors.swatchGrid}="${carouselID}"]`);
                const summaryBar = section.querySelector(selectors.summary);
                const nextArrow = section.querySelector(selectors.variantCarouselNext);
                const prevArrow = section.querySelector(selectors.variantCarouselPrev);
                const viewportNode = carousel.querySelector(selectors.variantCarouselViewport);
                const options = {
                    loop: true,
                    align: 'center',
                    dragFree: false,
                };
                const embla = EmblaCarousel(viewportNode, options, [ClassNames()]);
                const slides = carousel.querySelectorAll(selectors.variantCarouselSlide);
                nextArrow.addEventListener('click', () => {
                    const selectedIndex = embla.selectedScrollSnap();
                    const nextSlide = slides[selectedIndex + 1];
                    const variantValue = nextSlide.getAttribute('data-variant-value');
                    if (!nextSlide)
                        return;
                    selectSwatch(variantValue);
                });
                prevArrow.addEventListener('click', () => {
                    const selectedIndex = embla.selectedScrollSnap();
                    const prevSlide = slides[selectedIndex - 1];
                    const variantValue = prevSlide.getAttribute('data-variant-value');
                    if (!prevSlide)
                        return;
                    selectSwatch(variantValue);
                });
                let startIndex = 0;
                const selectedInput = carousel.querySelector('input[type="radio"]:checked');
                const selectedVariantValue = selectedInput === null || selectedInput === void 0 ? void 0 : selectedInput.value;
                const selectSwatch = (variantValue, scrollindex) => {
                    const input = swatchGrid.querySelector(`input[type="radio"][value="${variantValue}"]`);
                    const imageWrapper = carousel.querySelector(`[data-variant-image="${variantValue}"] > img`);
                    if (input) {
                        input.click();
                        swatchGrid.querySelector('legend > span').innerHTML = variantValue;
                        if (imageWrapper) {
                            const newSrc = imageWrapper.src.split('&width=')[0];
                            summaryBar.innerHTML = `<img src="${newSrc + '&width=100'}" width="80" height="100" alt="${variantValue}">`;
                        }
                        if (scrollindex != null) {
                            embla.scrollTo(scrollindex);
                        }
                    }
                };
                slides.forEach((slide, index) => {
                    if (slide.getAttribute('data-variant-value') === selectedVariantValue) {
                        const variantValue = slide.getAttribute('data-variant-value');
                        startIndex = index;
                        selectSwatch(variantValue, index);
                    }
                    slide.addEventListener('click', () => {
                        const variantValue = slide.getAttribute('data-variant-value');
                        if (!variantValue)
                            return;
                        selectSwatch(variantValue, index);
                    });
                });
                // Initial position
                embla.scrollTo(startIndex, true);
                embla.on('select', () => {
                    const selectedIndex = embla.selectedScrollSnap();
                    const selectedSlide = slides[selectedIndex];
                    const variantValue = selectedSlide.getAttribute('data-variant-value');
                    if (!selectedSlide)
                        return;
                    selectSwatch(variantValue);
                });
                // Associated Swatches
                if (swatchGrid) {
                    const swatchButtons = swatchGrid.querySelectorAll(selectors.swatchGridSwatch);
                    swatchButtons.forEach((button, index) => {
                        button.addEventListener('click', () => {
                            const variantValue = button.getAttribute('data-variant-value');
                            if (!variantValue)
                                return;
                            selectSwatch(variantValue, index);
                        });
                    });
                }
            });
        }
        // Accordions
        const openAccordion = (accordion) => {
            const content = accordion.querySelector(selectors.accordionContent);
            accordion.classList.add(classes.accordionOpen);
            content.style.maxHeight = content.scrollHeight + 'px';
        };
        const closeAccordion = (accordion) => {
            const content = accordion.querySelector(selectors.accordionContent);
            accordion.classList.remove(classes.accordionOpen);
            content.style.maxHeight = null;
        };
        const productAccordionBlocks = productInfo.querySelectorAll(selectors.productAccordionBlock);
        productAccordionBlocks.forEach((accordion) => {
            const title = accordion.querySelector(selectors.accordionTitle);
            const content = accordion.querySelector(selectors.accordionContent);
            if (content.hasAttribute(selectors.openOnLoad)) {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
            if (title && content) {
                title.onclick = () => {
                    if (content.style.maxHeight) {
                        closeAccordion(accordion);
                        accordion.classList.remove(classes.accordionOpen);
                    }
                    else {
                        productAccordionBlocks.forEach((accordion) => closeAccordion(accordion));
                        openAccordion(accordion);
                        accordion.classList.add(classes.accordionOpen);
                        setTimeout(() => {
                            const rect = title.getBoundingClientRect();
                            const inView = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
                            const scrollOffset = 100;
                            const scrollPosition = window.scrollY + rect.top - scrollOffset;
                            if (!inView) {
                                window.scrollTo({
                                    top: scrollPosition,
                                    behavior: 'auto',
                                });
                            }
                        }, 500);
                    }
                };
            }
        });
        window.addEventListener('resize', () => {
            productAccordionBlocks.forEach((accordion) => {
                const content = accordion.querySelector(selectors.accordionContent);
                if (content && content.style.maxHeight) {
                    openAccordion(accordion);
                }
            });
        });
    });
};
export { product };
